import React, { useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../middleware/ThemeContext';
import ContactsListing from './ContactsListing';

const MainContent = styled.div<{ theme: any }>(({ theme }) => ({
    flexGrow: 1,
    backgroundColor: theme.colors.contentBackground,
    color: theme.colors.contentText,
    minWidth: '600px',
}));

type OutletContextType = {
    setSelectedEntity?: (type: "contact" | "organization", id: number) => void;
    setRefreshTrigger?: React.Dispatch<React.SetStateAction<number>>;
    refreshTrigger?: number;
};

const Contacts: React.FC = () => {
    const { theme } = useTheme();
    const navigate = useNavigate();

    const {
        setSelectedEntity,
        setRefreshTrigger,
        refreshTrigger,
    } = useOutletContext<OutletContextType>();

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('authData') || '{}')?.accessToken;
        if (!token) navigate('/');
    }, [navigate]);

    return (
        <MainContent theme={theme}>
            <ContactsListing
                onEditContact={(id) => {
                    setSelectedEntity && setSelectedEntity('contact', id);
                }}
                refreshTrigger={refreshTrigger}
            />
        </MainContent>
    );
};

export default Contacts;
